export default __webpack_public_path__ + "locales/finances.ky.json";